module.exports = __webpack_public_path__ + "static/img/qpGame1.0272e01.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/qpGame1.webp
// module id = 3eoe
// module chunks = 3